import { render, staticRenderFns } from "./comingsoon_timer.vue?vue&type=template&id=85117982&"
import script from "./comingsoon_timer.vue?vue&type=script&lang=js&"
export * from "./comingsoon_timer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports